// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2z3JU","list":"PatternAutocomplete_list__3KYim"};